import React from 'react'
import type { LanguageTokens } from 'i18n'
import { useTranslation } from 'i18n'
import { Region, Pill } from './ConnectionStatus.styles'
import { useConnectionStatus } from './ConnectionStatus.hooks'
import type { ConnectionStatusKind } from './types'

const messageByKind: Record<ConnectionStatusKind, LanguageTokens> = {
  offline: 'Você está sem internet. Alguns conteúdos podem não carregar.',
  slow: 'Sua internet está lenta. Estamos carregando...',
  reconnected: 'Internet de volta!'
}

const ConnectionStatus = () => {
  const { t } = useTranslation()
  const { status } = useConnectionStatus()

  return (
    <Region role="status" aria-live="polite" data-testid="connection-status">
      {status && (
        <Pill kind={status} data-testid={`connection-status-${status}`}>
          {t(messageByKind[status])}
        </Pill>
      )}
    </Region>
  )
}

export default ConnectionStatus
